import React, { useContext, useEffect } from 'react';
import { buriedPoint } from '@/pages/home/utils/buriedPoint';
import { LayoutContext } from '@/pages/benchmark/state/LayoutContext';
import { BENCHMARK_SYSTEM } from '@/pages/benchmark/_config/constant';
import { getLogTypeId } from '@/pages/benchmark/utils/utils';
import { CommonDashboardReport } from "@home/components/CommonDashboardReport";


const Datalab = () => {
  const { frameType, currentMenu } = useContext(LayoutContext);
  useEffect(() => {
    if (!currentMenu) {
      return;
    }
    const { id = '', name_en: nameEn } = currentMenu || {};
    const logObj = {
      pageId: '800401',
      menuId: id,
      pageName: nameEn,
      extInfo: nameEn,
      pagePath: `/datalab/report/${nameEn || ''}`,
      uidType: '', // 基准打点不包含uidType
      typeId: getLogTypeId(frameType),
    };
    buriedPoint(logObj);
  }, [currentMenu, frameType]);
  const dashboardId = currentMenu.dashboard_custom_id;
  
  return (<CommonDashboardReport
    className={'dbl-force-bubble-popup'}
    dashboardId={dashboardId}
    dashboardName={currentMenu?.name_en ?? ''}
    system={getLogTypeId(frameType) || BENCHMARK_SYSTEM}
    reportInfo={{
      typeId: getLogTypeId(frameType),
      reportPageId: '800401',
      dashboardId,
      pageName: currentMenu.name_en,
      menuId: currentMenu.id,
      pageId: '800401',
      uid: '',
      uidType: '',
    }}
  />);
  
};

export default Datalab;